<section class="peca-kanban-column" [style.height.px]="height()">
  <header class="peca-kanban-column__header">
    <span class="peca-kanban-column__header__indicator">{{ indicator() }}</span>
    <span class="peca-kanban-column__header__title">{{ title() }}</span>
  </header>

  <main class="peca-kanban-column__content">
    @if (cardsLoading()) { @for (item of skeletonArray; track $index) {
    <peca-kanban-load-card-skeleton />
    } }@else if(cardsFailed()) {
    <div class="peca-kanban-column__msg-fallback">
      <h1>Ops! Algo deu errado</h1>
      <p>Não conseguimos carregar as informações no momento.</p>
      <button pdsButton="terciary" (click)="retry.emit()">
        <span class="icon"> refresh</span>
        <span>Tentar novamente</span>
      </button>
    </div>
    }@else if(isEmpty()) {
    <div class="peca-kanban-column__msg-fallback">
      <p>{{ emptyMessage() }}</p>
    </div>
    }@else {
    <ng-content></ng-content>
    }
  </main>
  <footer></footer>
</section>
